import { LogLevel } from "./log-level";

interface LogProps {
    logLevel: number;
    name: string;
    text: string;
    error?: any;
}

export class Logger {
    static level: number = LogLevel.INFO;

    static setLogLevel(level: number): void {
        if (LogLevel.allowed(level)) {
            Logger.level = level;
        } else {
            console.warn(`Unknown log level: ${level}.`);
        }
    }

    static _shouldLog(logLevel: number): boolean {
        return logLevel >= Logger.level;
    }

    static _formatMessage(name: string, text: string): string {
        return `[${name}] ${text}`;
    }

    static _log(props: LogProps): void {
        if (!Logger._shouldLog(props.logLevel)) return;

        const formatted = Logger._formatMessage(props.name, props.text);
        let message = formatted;

        if (props.logLevel === LogLevel.WARN || props.logLevel === LogLevel.ERROR) {
            const callerInfo = Logger._getCallerInfo();
            message += `\n${callerInfo}`;
        }

        switch (props.logLevel) {
            case LogLevel.INFO:
                console.log(message);
                break;
            case LogLevel.WARN:
                console.warn(message);
                break;
            case LogLevel.ERROR:
                if (props.error) {
                    console.error(message, props.error);
                }
                else {
                    console.error(message);
                }
                break;
        }
    }

    static _getCallerInfo(): string {
        try {
            const error = new Error();
            const stack = error.stack ? error.stack.split("\n") : [];
            const callerLine = stack[4]?.trim() || '(Unknown location)';
            return callerLine;
        } catch (e) {
            return '(Unknown location)';
        }
    }

    static info(name: string, text: string): void {
        Logger._log({
            logLevel: LogLevel.INFO,
            name: name,
            text: text,
        });
    }

    static warn(name: string, text: string): void {
        Logger._log({
            logLevel: LogLevel.WARN,
            name: name,
            text: text,
        });
    }

    static error(name: string, text: string, error?: any): void {
        Logger._log({
            logLevel: LogLevel.ERROR,
            name: name,
            text: text,
            error: error,
        });
    }
}
